const childRoutes = prop => [
    {
        path: 'form',
        name: prop + '.form',
        meta: { auth: true },
        component: () => import('../pages/street-children/Form.vue')
    },
    {
        path: 'list',
        name: prop + '.list',
        meta: { auth: true },
        component: () => import('../pages/street-children/List.vue')
    }
]
const routes = [
    {
        path: '/street-children-service/street-children',
        name: 'street_children_service.street_children',
        component: () => import('@/layouts/StreetChildrenService.vue'),
        meta: { auth: true },
        children: childRoutes('street_children_service.street_children')
    }
]

export default routes
